module.exports = __webpack_public_path__ + "images/Premium_black_horizontal.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo/Premium_black_horizontal.svg
// module id = 113
// module chunks = 0